<div class="my-scorecard">
    <cmps-card-component
        class="insight-component-item"
        [cardNameLabel]="_i18n._9295_MY_SCORECARDS | translate"
        [isLoading]="state?.pending?.reload"
        [disabledDropdown]="true"
        [isExpanded]="_isExpanded"
        [hasRefreshAction]="_isExpanded === false && state.pending.hasData"
        (refreshAction)="_onReload()"
        [hasExpandAction]="state.pending.hasData"
        (expandAction)="_onExpandClick()"
        [data]="bodyContent"
    ></cmps-card-component>
</div>

<ng-template #bodyContent>
    <ng-container *ngIf="!state.pending.hasData && !state.pending.reload">
        <div class="my-scorecard-card--no-data">
            <h2 class="my-scorecard-card--no-data-value">
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </h2>
        </div>
    </ng-container>

    <button
        class="ml-2 cmps-button--sm p-1 scorecard-launch-button"
        *ngIf="_isExpanded === true"
        cmpsButton
        (click)="_launchScorecard()"
    >
        <cmps-icon svgIcon="launch"></cmps-icon>
        <span cmpsButtonLabel>{{
            _i18n._9946_LAUNCH_SCORECARDS | translate
        }}</span>
    </button>

    <ng-container
        *ngIf="
            _isExpanded === false &&
            state.pending.hasData &&
            state.scorecardData
        "
    >
        <div class="insight-component-item-slider">
            <cmps-card-header-row-component
                [cardHeaderLabel]="
                    state?.scorecardData?.headerRowData?.titleLabel
                "
                [timePeriod]="state?.scorecardData?.headerRowData?.periodDate"
                [isShowingIcon]="
                    state?.scorecardData?.headerRowData?.hasHeaderIcon
                "
            ></cmps-card-header-row-component>
            <cmps-scorecard-sub-header
                [superGroupLabel]="
                    state?.scorecardData?.scorecardSubHeader?.supergroupLabel
                "
                [superGroupValue]="
                    state?.scorecardData?.scorecardSubHeader?.supergroupValue
                "
                [scorecardId]="
                    state?.scorecardData?.scorecardSubHeader?.scorecardId
                "
                [scorecardValue]="
                    state?.scorecardData?.scorecardSubHeader?.scorecardValue
                "
                [disabled]="
                    state?.scorecardData?.scorecardSubHeader?.isDisabled
                "
                [options]="state?.periodOptions"
                [selected]="state?.selectedPeriodType?.periodTypeName"
                (selectedAction)="_onPeriodTypeChange($event)"
            ></cmps-scorecard-sub-header>
            <cmps-scorecard-score-section
                [adjustScoreData]="state.scorecardData?.adjustScoreData"
                [originalScoreData]="state.scorecardData?.originalScoreData"
                [trendData]="state.scorecardData?.trendData"
                [dropdownMenuData]="state.scorecardData?.dropdownMenuData"
                (trendAction)="_onTrendAction()"
                (selectedAction)="_onSelectAction($event)"
            ></cmps-scorecard-score-section>
            <cmps-scorecard-pillar-information
                [data]="state?.scorecardData?.scorecardPillarInformationData"
            ></cmps-scorecard-pillar-information>
            <cmps-scorecard-category
                *ngIf="state.scorecardData?.scCategory"
                [categoryColor]="state.scorecardData?.scCategory.color"
                [categoryLabel]="state.scorecardData?.scCategory.label"
                [categoryValueLabel]="state.scorecardData?.scCategory.value"
            ></cmps-scorecard-category>
            <cmps-scorecard-rank-bonus
                *ngIf="state?.scorecardData?.rankData?.isVisible"
                [isOpen]="state?.scorecardData?.rankData?.isVisible"
                [label]="state?.scorecardData?.rankData?.titleLabel"
                [data]="state?.scorecardData?.rankData?.data"
                (closeAction)="_onSelectAction(_menuItems.ADD_RANK)"
            ></cmps-scorecard-rank-bonus>
            <cmps-scorecard-rank-bonus
                *ngIf="state?.scorecardData?.bonusData?.isVisible"
                [isOpen]="state?.scorecardData?.bonusData?.isVisible"
                [label]="state?.scorecardData?.bonusData?.titleLabel"
                [data]="state?.scorecardData?.bonusData?.data"
                (closeAction)="_onSelectAction(_menuItems.ADD_BONUS)"
            ></cmps-scorecard-rank-bonus>
        </div>
    </ng-container>
    <ng-container
        *ngIf="
            _isExpanded === false && state.selectedScorecardHistory?.length > 1
        "
    >
        <button
            class="slider-button prev"
            (click)="_onPrevSlide()"
            *ngIf="!state.historyPos?.isAtFirst"
        >
            <cmps-icon svgIcon="arrow-left-drop-circle"></cmps-icon>
        </button>
        <button
            class="slider-button next"
            (click)="_onNextSlide()"
            *ngIf="!state.historyPos?.isAtLast"
        >
            <cmps-icon svgIcon="arrow-right-drop-circle"></cmps-icon>
        </button>
    </ng-container>

    <ng-container *ngIf="_isExpanded === true">
        <cmps-scorecard></cmps-scorecard>
    </ng-container>
</ng-template>
